module.exports = __webpack_public_path__ + "img/25.16e4e309.png";